var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartB16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M7.474 3.262 8 3.778l.526-.516.463-.456a3.7 3.7 0 0 1 2.596-1.056c.976 0 1.91.381 2.596 1.056a3.55 3.55 0 0 1 1.069 2.533c0 .948-.383 1.86-1.069 2.534l-.463.456L8 13.949l-5.717-5.62-.464-.456A3.55 3.55 0 0 1 .75 5.339c0-.947.383-1.859 1.069-2.533A3.7 3.7 0 0 1 4.415 1.75c.976 0 1.91.381 2.596 1.056z"
})));
export default SvgIconHeartB16;